export function getGlobalObject() {
    if (typeof window !== 'undefined') {
        return window
    }
    if (typeof global !== 'undefined') {
        return global
    }
    if (typeof self !== 'undefined') {
        return self
    }
    return {}
}


export const globalObject = getGlobalObject()
